<template>
    <Breadcrumbs main="Job Search" title="Job Details" />
    <div class="container-fluid">
        <div class="row">
            <jobSidebar />
            <jobDetails />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const jobSidebar = defineAsyncComponent(() => import("@/components/commen/jobSidebar.vue"))
const jobDetails = defineAsyncComponent(() => import("@/components/theme/job/details/jobDetails.vue"))
</script>